<div class="d-flex flex-column align-items-center nxt-px-32 nxt-py-40">
  <div class="nxt-mb-20">
    <img [src]="assetsUrl + 'assets/images/security.svg'" alt="Security" />
  </div>

  <div class="text-center">
    <h2 class="nxt-font-20 font-weight-bold nxt-mb-8">Two-step verification</h2>
    <p class="nxt-font-14 m-0 nxt-text-gray">{{ subtitle }}<span *ngIf="effectiveAuthType !== 'ga' && email" class="nxt-text-black font-weight-semibold nxt-ml-6">{{email}}</span></p>
  </div>

  <div class="d-flex flex-column nxt-mt-32 otp-section">
    <div class="nxt-font-10 nxt-mb-8">Enter verification code<span class="nxt-text-error">*</span></div>
    <ngx-otp-input
      [options]="otpOptions"
      [disabled]="isVerifying"
      (otpChange)="onOtpChange($event)"
      (otpComplete)="onOtpComplete($event)"
    ></ngx-otp-input>
  </div>

  <div class="d-flex justify-content-center nxt-mt-40 nxt-mb-16">
    <button type="button" class="btn btn-secondary btn-lg nxt-mr-16" [disabled]="isVerifying" (click)="cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary btn-lg"
      [disabled]="isVerifying || otpValue.length !== otpLength"
      (click)="verify()"
    >
      Verify
    </button>
  </div>

  <div *ngIf="authType === 'otp'" class="d-flex justify-content-center  nxt-mb-24">
    <div *ngIf="timeRemaining !== '00:00'; else resendOtp">
      <span class="nxt-font-14 nxt-text-gray font-weight-semibold nxt-mr-6">Resend OTP after</span>
      <span class="nxt-font-14 nxt-text-black font-weight-semibold">{{timeRemaining}}</span>
    </div>
    <ng-template #resendOtp>
      <span class="nxt-font-14 nxt-text-gray nxt-mr-6">Didn’t receive a code?</span>
      <button
        type="button"
        class="btn btn-link p-0 nxt-font-14 font-weight-semibold nxt-text-primary text-transform-none"
        (click)="requestOtp()"
      >
        Resend OTP
      </button>
    </ng-template>
  </div>

  <hr class="w-100 m-0">

  <div class="nxt-text-gray nxt-mt-24">
    <span class="nxt-font-14 nxt-mr-6">Having a problem? Contact</span>
    <a class="nxt-font-14 nxt-text-dark-blue" href="mailto:help@netcorecloud.com">help@netcorecloud.com.</a>
  </div>
</div>


